import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const DharmaPage = lazy(() => import('../pages/dharma/page'));
const PracticePage = lazy(() => import('../pages/practice/page'));
const CommunityPage = lazy(() => import('../pages/community/page'));
const YongwangdanPage = lazy(() => import('../pages/yongwangdan/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/dharma',
    element: <DharmaPage />,
  },
  {
    path: '/practice',
    element: <PracticePage />,
  },
  {
    path: '/community',
    element: <CommunityPage />,
  },
  {
    path: '/yongwangdan',
    element: <YongwangdanPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
